import React, { useEffect, useState } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig"; 
import moment from "moment";

const InvoiceHistoryModal = ({ invoiceId, invoiceNumber, onClose }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (invoiceId) fetchHistory();
  }, [invoiceId]);

  const fetchHistory = async () => {
    try {
      const res = await apiService.getAll(`${config.GETINVOICEHISTORY}/${invoiceId}`);
      setHistory(res);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mghistory-modal-overlay">
      <div className="mghistory-modal-content">
        <div className="mghistory-modal-header">
          <h4>Transaction History: <span className="text-primary">{invoiceNumber}</span></h4>
          <button className="mghistory-close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="mghistory-modal-body">
          {loading ? (
            <div className="text-center p-5">
               <div className="spinner-border text-primary" role="status"></div>
               <p className="mt-2 text-muted">Loading history...</p>
            </div>
          ) : history.length === 0 ? (
            <p className="text-center p-5 text-muted">No history found for this invoice.</p>
          ) : (
            <div className="mghistory-list-container">
              {history.map((item, index) => (
                <div key={index} className="mghistory-item">
                  {/* Left Side: Date & Time */}
                  <div className="mghistory-time-column">
                    <span className="mghistory-date">{moment(item.date).format("MMM DD, YYYY")}</span>
                    <span className="mghistory-time">{moment(item.date).format("hh:mm A")}</span>
                  </div>

                  {/* Middle: The Line and Dot */}
                  <div className="mghistory-divider-column">
                    <div className={`mghistory-dot ${item.action.toLowerCase().includes("payment") ? "dot-success" : "dot-primary"}`}></div>
                    {index !== history.length - 1 && <div className="mghistory-line"></div>}
                  </div>

                  {/* Right Side: Content */}
                  <div className="mghistory-content-column">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <h5 className="mghistory-action-title">{item.action}</h5>
                            <p className="mghistory-desc">{item.description}</p>
                        </div>
                        <div className="text-end">
                            <div className="mghistory-amount">₹{Number(item.amount).toLocaleString("en-IN", {minimumFractionDigits: 2})}</div>
                            {item.paymentMode && <span className="mghistory-payment-badge">{item.paymentMode}</span>}
                        </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .mghistory-modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(15, 23, 42, 0.7); 
          display: flex; justify-content: center; align-items: center; z-index: 2000;
          backdrop-filter: blur(4px);
        }
        .mghistory-modal-content { 
            background: white; 
            width: 600px; 
            border-radius: 12px; 
            overflow: hidden; 
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); 
        }
        .mghistory-modal-header { 
            padding: 20px 24px; 
            background: #fff; 
            border-bottom: 1px solid #f1f5f9; 
            display: flex; justify-content: space-between; align-items: center; 
        }
        .mghistory-modal-header h4 { margin: 0; font-size: 1.1rem; font-weight: 700; color: #1e293b; }
        .mghistory-close-btn { border: none; background: #f1f5f9; width: 32px; height: 32px; border-radius: 50%; font-size: 20px; cursor: pointer; color: #64748b; transition: all 0.2s; }
        .mghistory-close-btn:hover { background: #e2e8f0; color: #0f172a; }

        .mghistory-modal-body { padding: 24px; max-height: 70vh; overflow-y: auto; }

        /* List Layout */
        .mghistory-list-container { display: flex; flex-direction: column; }
        .mghistory-item { display: flex; min-height: 80px; }

        /* 1. Time Column */
        .mghistory-time-column { width: 100px; display: flex; flex-direction: column; text-align: right; padding-right: 15px; }
        .mghistory-date { font-size: 13px; font-weight: 700; color: #334155; }
        .mghistory-time { font-size: 11px; color: #94a3b8; font-weight: 500; }

        /* 2. Divider Column */
        .mghistory-divider-column { width: 30px; display: flex; flex-direction: column; align-items: center; position: relative; }
        .mghistory-dot { 
            width: 14px; height: 14px; border-radius: 50%; 
            border: 3px solid white; 
            box-shadow: 0 0 0 2px #e2e8f0;
            z-index: 2; margin-top: 3px;
        }
        .dot-primary { background: #2563eb; box-shadow: 0 0 0 2px #dbeafe; }
        .dot-success { background: #10b981; box-shadow: 0 0 0 2px #d1fae5; }
        
        .mghistory-line { 
            position: absolute; top: 18px; bottom: 0; width: 2px; 
            background: #f1f5f9; z-index: 1; 
        }

        /* 3. Content Column */
        .mghistory-content-column { flex: 1; padding-left: 10px; padding-bottom: 25px; }
        .mghistory-action-title { font-size: 14px; font-weight: 700; color: #1e293b; margin: 0; }
        .mghistory-desc { font-size: 12px; color: #64748b; margin: 4px 0 0 0; line-height: 1.4; }
        
        .mghistory-amount { font-size: 15px; font-weight: 800; color: #0f172a; }
        .mghistory-payment-badge { 
            display: inline-block;
            background: #f8fafc; color: #475569; 
            font-size: 10px; font-weight: 700; 
            padding: 2px 8px; border-radius: 4px; 
            border: 1px solid #e2e8f0;
            margin-top: 5px;
            text-transform: uppercase;
        }

        /* Hide last line */
        .mghistory-item:last-child .mghistory-content-column { padding-bottom: 10px; }
      `}</style>
    </div>
  );
};

export default InvoiceHistoryModal;